import React from 'react';
import { Amplify } from 'aws-amplify';
import { getGraphEndpointUrl } from '@esub-engineering/react-common-lib';
import { useAuth } from '../../../auth/hooks';

type AwsAmplifyControllerProps = {
  children: React.ReactNode | React.ReactChild | React.ReactChildren;
};

export const AwsAmplifyController = React.memo<AwsAmplifyControllerProps>(({ children }) => {
  const { getIdToken } = useAuth();

  const authToken = getIdToken();

  Amplify.configure(
    {
      API: {
        GraphQL: {
          endpoint: getGraphEndpointUrl(window.location.href),
          region: process.env.REACT_APP_AWS_REGION,
          defaultAuthMode: process.env.REACT_APP_AWS_AUTH_MODE as any,
        },
      },
    },
    {
      API: {
        GraphQL: {
          headers: async () => ({
            Authorization: authToken,
          }),
        },
      },
    }
  );

  return <>{children}</>;
});
